module.exports = __webpack_public_path__ + "img/solution3_banner_txt.f08cefe7.png";